import { Images } from "../../../../../utils/imageConstants";
import PlayoffBadge from "./matchesDetails/PlayoffBadge";
import type { IMatchSummary } from "./types/IMatches";
import { useNavigate } from "react-router-dom";
import { formatDateAndTime, getMatchEquationText, getPlayerImageUrl, getTeamScores, isTestMatch } from "../../../../../helper/helper";

type pastMatchProps = {
  matches: IMatchSummary[];
  isLoading: boolean;
  viewList: boolean;
};

const PastMatches = ({ matches, isLoading, viewList }: pastMatchProps) => {
  const navigate = useNavigate();

  if (isLoading) {
    return <p>Loading…</p>;
  }

  if (!matches || matches.length === 0) {
    return (
      <div className="no-data-found">
        <img src={Images.my_leagues_no} alt="No Gallery" />
        <p>No Matches Found</p>
      </div>
    );
  }
  const data: IMatchSummary[] = matches && matches.length > 0 ? matches : [];

  // Helper function to format umpire names
  const getUmpireNames = (match: IMatchSummary) => {
    if (match?.availableUmpireResponse?.isUmpire && match?.availableUmpireResponse?.name?.trim()) {
      return match.availableUmpireResponse.name;
    }
    return "TBD";
  };

  // Helper function to get match result text
  const getMatchResultText = (match: IMatchSummary) => {
    const text = getMatchEquationText(match);
    return text && text !== "-" ? text.toUpperCase() : "MATCH COMPLETED";
  };


  return (
    <div>
      {viewList ? (
          data?.map((match: IMatchSummary, index: number) => (
      <div className="frame">
      <p className="header-info-text">
        {getMatchEquationText(match)}
      </p>

      <div className="div">
        <div className="div-2">
          <div className="match-info">
            <div className="match-type">{match?.matchType || "-"}</div>
            <PlayoffBadge playoffType={match?.playoffType} />

            <div className="match-details">
              <p className="text-wrapper">
                {formatDateAndTime(match?.startDate)||"-"}&nbsp;&nbsp; |&nbsp;&nbsp; {match?.leagueName||"-"}&nbsp;&nbsp;|&nbsp;&nbsp;{match?.tournament?.tournamentName ||"-"}
              </p>

              <p className="p">
                Umpire : {match?.availableUmpireResponse?.name || "-"}
              </p>
            </div>
          </div>

          {/* <img className="line" alt="Line" src={greenDot} /> */}

          <div className="div-3">
            <p className="header-info-text-2">
              {match?.groundId?.groundName || "-"}
            </p>

            <div className="div-4">
              {(() => {
                const { firstTeamScore, secondTeamScore, firstTeamScoreText, secondTeamScoreText, firstTeamName, secondTeamName, showYetToBat } = getTeamScores(match);
                const firstTeamImage = match?.teamOne?.teamName === firstTeamName 
                  ? match?.teamOne?.imageUrl 
                  : match?.teamTwo?.imageUrl;
                const secondTeamImage = match?.teamOne?.teamName === secondTeamName 
                  ? match?.teamOne?.imageUrl 
                  : match?.teamTwo?.imageUrl;

                return (
                  <>
                    <div className="div-5">
                      <div className="team-info">
                        <div className="team-logo">
                          <img className="ellipse" alt="Ellipse" src={getPlayerImageUrl(firstTeamImage)||Images.card_info_image} />
                        </div>
                      </div>

                      <div className="div-6">
                        <div className="team-name">{firstTeamName || "-"}</div>

                        <div className="div-7">
                          {firstTeamScore ? (
                            <>
                              <div className="team-score">{firstTeamScoreText}</div>

                              {!isTestMatch(match?.matchType) && (
                              <p className="team-score-2">
                                <span className="span">({firstTeamScore.over}.
                                          {firstTeamScore.ball})</span>

                                <span className="text-wrapper-2">{""}</span>
                              </p>
                              )}
                            </>
                          ) : (
                            <div className="team-score">-</div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="mask-group">
                      <img
                        className="rectangle"
                        alt="Rectangle"
                        src={Images.vs_icon}
                      />
                    </div>

                    <div className="div-5">
                      <div className="div-6">
                        <div className="team-name">{secondTeamName || "-"}</div>

                        <div className="div-7">
                          {showYetToBat ? (
                            <div className="team-score">Yet to Bat</div>
                          ) : secondTeamScore ? (
                            <>
                              <div className="team-score">{secondTeamScoreText}</div>

                              {!isTestMatch(match?.matchType) && (
                              <p className="team-score-2">
                                <span className="span">({secondTeamScore.over}.
                                          {secondTeamScore.ball})</span>

                                <span className="text-wrapper-2">{""}</span>
                              </p>
                              )}
                            </>
                          ) : (
                            <div className="team-score">-</div>
                          )}
                        </div>
                      </div>

                      <div className="team-info">
                        <div className="team-logo">
                          <img className="ellipse" alt="Ellipse" src={getPlayerImageUrl(secondTeamImage)||Images.card_info_image} />
                        </div>
                      </div>
                    </div>
                  </>
                );
              })()}
            </div>
          </div>
        </div>
        <div className="create-button">
          <div className="header-title"  onClick={() =>
                      navigate(`/matches-details/${match?.matchId}`)
                    }>Match Center</div>
        </div>
      </div>
    </div>
        ))
      ) : (
        <div className="live-matches-grid">
          {data.map((match: IMatchSummary) => {
            return (
              <div className="live-match-card" key={match?.matchId}>
                <div className="live-match-content">
                  <div className="live-match-header">
                    <div className="live-indicator">
                      <span className="result-tag">{getMatchResultText(match)}</span>
                      <div className="match-info">
                        <span className="match-context-league">
                          {match?.leagueName?.trim() || "—"}
                        </span>
                        <span className="separator">|</span>
                        <span className="match-context-tournament">
                          {match?.tournament?.tournamentName?.trim() || "—"}
                        </span>
<PlayoffBadge playoffType={match?.playoffType} />
                      </div>
                    </div>
                    <div className="divider-line"></div>
                    <div className="teams-section">
                      {(() => {
                        const { firstTeamScore, secondTeamScore, firstTeamScoreText, secondTeamScoreText, firstTeamName, secondTeamName, showYetToBat } = getTeamScores(match);
                        const firstTeamImage =
                          match?.teamOne?.teamName === firstTeamName
                            ? match?.teamOne?.imageUrl
                            : match?.teamTwo?.imageUrl;
                        const secondTeamImage =
                          match?.teamOne?.teamName === secondTeamName
                            ? match?.teamOne?.imageUrl
                            : match?.teamTwo?.imageUrl;
                        return (
                          <>
                            <div className="team-row">
                              <div className="team-info">
                                <div className="team-logo">
                                  <img
                                    src={getPlayerImageUrl(firstTeamImage) || Images.card_info_image}
                                    alt="Team Logo"
                                  />
                                </div>
                                <span className="team-name">
                                  {firstTeamName}
                                </span>
                              </div>
                              <div className="team-score">
                                {firstTeamScore ? (
                                  <div className="score-with-overs">
                                    <span className="score">
                                      {firstTeamScoreText}
                                    </span>
                                    {!isTestMatch(match?.matchType) && (
                                    <span className="overs">
                                      ({firstTeamScore.over}.
                                      {firstTeamScore.ball} ov)
                                    </span>
                                    )}
                                  </div>
                                ) : (
                                  <span className="score">-</span>
                                )}
                              </div>
                            </div>

                            <div className="team-row">
                              <div className="team-info">
                                <div className="team-logo">
                                  <img
                                    src={getPlayerImageUrl(secondTeamImage) || Images.card_info_image}
                                    alt="Team Logo"
                                  />
                                </div>
                                <span className="team-name">
                                  {secondTeamName}
                                </span>
                              </div>
                              <div className="team-score">
                                {showYetToBat ? (
                                  <span className="score">Yet to Bat</span>
                                ) : secondTeamScore ? (
                                  <div className="score-with-overs">
                                    <span className="score">
                                      {secondTeamScoreText}
                                    </span>
                                    {!isTestMatch(match?.matchType) && (
                                    <span className="overs">
                                      ({secondTeamScore.over}.
                                      {secondTeamScore.ball} ov)
                                    </span>
                                    )}
                                  </div>
                                ) : (
                                  <span className="score">-</span>
                                )}
                              </div>
                            </div>
                          </>
                        );
                      })()}
                    </div>
                  </div>

                  <div className="match-details">
                    <p className="umpire-info">
                      <span className="label">Umpire : </span>
                      <span className="value">{match?.umpire || "TBD"}</span>
                    </p>
                    <div className="venue-info">
                      <div className="venue-icon">
                        <img src={Images.blue_location} alt="Venue" />
                      </div>
                      <span className="venue-name">
                        {match?.groundId?.groundName || match?.city}
                      </span>
                    </div>
                  </div>

                  <div className="divider-line"></div>

                  <button
                    className="match-center-btn"
                    onClick={() =>
                      navigate(`/matches-details/${match?.matchId}`)
                    }
                  >
                    <span>Match Center</span>
                    <div className="btn-icon">
                      <img src={Images.scorecard_icon} alt="Arrow" />
                    </div>
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
      {matches?.length === 0 && (
        <div className="no-data-found">
          <img src={Images.my_leagues_no} className="n" alt="no-data-image" />
          <p>NO MATCHES FOUND</p>
        </div>
      )}
    </div>
  );
};

export default PastMatches;

// availableUmpireResponse (if null ---No umpire else i will get object)
// startDate-endDate (for Match date)
